export const USERROLEENUM = {
  ADMIN: 1,
  HR: 2,
  FINANCE: 3,
  MANAGER: 4,
  EMPLOYEE: 5,
  TSApprover: 6,
} as const;

export const daysDataEnum = {
  WEEKDAY: 1,
  WEEKEND: 2,
  HOLIDAY: 3,
} as const;

export const ReportStatusEnum = {
  New: 1,
  Waitingforapproval: 2,
  Approved: 3,
  Returnedforreview: 4,
  Senttoclient: 5,
  Waitingforpartialapproval: 6,
  PartiallyApproved: 7,
} as const;

export const ReportFormButtonPermissionStatusEnum = {
  user: [
    ReportStatusEnum.Approved,
    ReportStatusEnum.PartiallyApproved,
    ReportStatusEnum.Senttoclient,
    ReportStatusEnum.Waitingforapproval,
    ReportStatusEnum.Waitingforpartialapproval,
  ],
} as const;

// IPMS
export const GoalsFlagStatusEnum = {
  save: 1,
  submit: 2,
  approved: 3,
  rejected: 4,
};

export const GoalsFlagListStatusEnum: Record<number, string> = {
  1: "Saved",
  2: "Added",
  3: "Approved",
  4: "Completed",
};

export const GoalsAssessmentFinalStatusSEnum: Record<number, string> = {
  2: "Employee Review Complete",
  3: "Employee & Manager Review Complete",
  4: "Completed 100%",
};

export const GoalsAssessmentFinalStatusSEnumother: Record<number, string> = {
  2: "Employee Review Complete",
  3: "Completed 100%",
};

export const GoalsAssessmentFinalStatusProgressbarSEnum: Record<number, string> = {
  2: "70%",
  3: "80%",
  4: "100%",
};

export const GoalsAssessmentFinalStatusProgressbarSEnumOther: Record<number, string> = {
  2: "60%",
  3: "100%",
};


export const GoalsAssessmentFinalwaitingStatusSEnum: Record<number, string> = {
  2: "Manager & HR Pending",
  3: "HR Pending",
  4: "",
};

export const GoalsAssessmentFinalStatuswaitingSEnumother: Record<number, string> = {
  2: "Manager Pending",
  3: "",
};

